export const SUBSCRIBED_COURSES_HEADING = "Your subscribed courses";

export const ALL_COURSES_HEADING = "Explore all courses";
